import styled from "styled-components";

export const SCStandardContract = styled.section`
  width: 100%;

  h1 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 120%;
  }

  > p {
    font-size: 16px;
    line-height: 160%;
    margin: 0 0 24px;
    color: #475569;
  }

  .doc-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
    text-decoration: none;
    color: inherit;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      border-color: #1e3a8a;
      box-shadow: 0 4px 12px rgba(30, 58, 138, 0.08);
      color: inherit;
    }
  }

  .doc-icon {
    flex: 0 0 44px;
    width: 44px;
    height: 44px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: #eef2ff;
    color: #1e3a8a;
  }

  .doc-body {
    flex: 1 1 auto;
    min-width: 0;
  }

  .doc-title {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    line-height: 140%;
  }

  .doc-meta {
    font-size: 13px;
    color: #64748b;
    margin: 4px 0 0;
  }

  .doc-badge {
    flex: 0 0 auto;
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 999px;
    background: #f1f5f9;
    color: #1e3a8a;
    letter-spacing: 0.02em;
  }

  @media (max-width: 576px) {
    .doc-card {
      gap: 12px;
      padding: 14px;
    }

    .doc-icon {
      flex: 0 0 36px;
      width: 36px;
      height: 36px;
    }

    .doc-title {
      font-size: 15px;
    }
  }
`;
